export const palette = {
  white: '#FFFFFF',
  black: '#000000',
  transparent: '#00000000',

  purple500: '#8533eb',

  blue200: '#F9F9F9',
  blue300: '#F1F5FF',
  blue350: '#70707E',
  blue400: '#E1E8FB',
  blue450: '#72728B',
  blue500: '#9090AB',
  blue550: '#7E7DBF',
  blue600: '#5b6bff',
  blue650: '#2e63ee',
  blue700: '#5351BD',
  blue800: '#29286A',

  gray100: '#F5F6F7',
  gray150: '#F0F3FB',
  gray250: '#fafafa',
  gray300: '#f7fafc',
  gray350: '#dfdfdf',
  gray400: '#d4d4d4',
  gray450: '#cecece',
  gray500: '#BABABE',
  gray600: '#828282',
  gray700: '#444444',
  gray800: '#2d2d2d',
  gray900: '#1A1A1A',

  blackAlpha850: '#000000d9',
  blackAlpha500: '#636363',
  blueAlpha200: '#7E7DBF33',

  green100: '#eafff1',
  green500: '#2c9d5b',
  green600: '#1e7d47',
  green700: '#155d35',

  red100: '#f7eef3',
  red200: '#c5056b',
  red500: '#d0021b',
  red600: '#8b0000',
  premium: '#fc2d38',
  warning: '#f4d689',

  gradientStart: '#8533EB',
  gradientMiddle: '#00C9B8',
  gradientEnd: '#00F06B',
};

export const semanticColors = {
  brand: {
    primary: palette.purple500,
    secondary: palette.blue800,
    accent: palette.blue650,
  },

  text: {
    primary: palette.blue800,
    secondary: palette.gray800,
    subtle: palette.blue450,
    inverse: palette.white,
    interactive: palette.blue700,
    heading: palette.gray900,
    tertiary: palette.blue300,
  },

  surface: {
    screen: palette.gray250,
    modal: palette.white,
    elevated: palette.white,
    subtle: palette.blue300,
    light: palette.gray300,
    soft: palette.gray350,
    variant: palette.gray250,
  },

  container: {
    primary: palette.white,
    secondary: palette.blue400,
    tertiary: palette.gray250,
  },

  border: {
    default: palette.blueAlpha200,
    light: palette.gray350,
    primary: palette.purple500,
    secondary: palette.gray450,
    divider: palette.blueAlpha200,
    elevated: palette.blue200,
    dark: palette.blue800,
  },

  badge: {
    success: {
      bg: palette.green100,
      text: palette.green500,
      border: palette.green100,
    },
    expired: {
      bg: palette.red100,
      text: palette.red200,
      border: palette.red100,
    },
  },

  state: {
    error: palette.red500,
    errorLight: palette.red100,
    warning: palette.warning,
    premium: palette.premium,
  },

  icon: {
    primary: palette.blue500,
    secondary: palette.gray500,
    subtle: palette.blue550,
    active: palette.blue800,
    inverse: palette.white,
    muted: palette.gray350,
  },

  onColors: {
    onTertiary: palette.white,
    onError: palette.white,
    onPrimaryContainer: palette.blue800,
    onSecondaryContainer: palette.blue800,
  },

  inverse: {
    surface: palette.gray900,
    onSurface: palette.white,
    primary: palette.white,
  },

  overlay: {
    shadow: palette.blackAlpha850,
    scrim: palette.blackAlpha850,
  },
};

export const componentColors = {};

export const colors = {
  palette,
  system: semanticColors,
  components: componentColors,
};

